import { FC } from 'react'
import { Button as AntButton, Modal } from 'antd'
import styled from 'styled-components';

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onConfirm: () => void;
  titleText: string;
  messageText: string;
  confirmText: string;
  cancelText?: string;
  className?: string;
  width?: number;
}

const PreTagLine = styled.pre`
  margin: 0;
  padding: 0;
  white-space: pre-line;
  font-size: 1.1rem;
  text-align:center;
`
const NoticeConfirmModal: FC<IProps> = ({
  visible,
  setVisible,
  onConfirm,
  titleText,
  messageText,
  confirmText,
  cancelText,
  className = '',
  width = 400,
}) => {
  const getFooter = () => {
    if (cancelText) {
      return [
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onConfirm}
          >
            {confirmText}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={() => setVisible(false)}
          >
            {cancelText}
          </AntButton>
        </div>
      ]
    } else {
      return [
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onConfirm}
          >
            {confirmText}
          </AntButton>
        </div>
      ]
    }
  }

  return (
    <Modal
      title={titleText}
      open={visible}
      onCancel={() => setVisible(false)}
      width={width}
      footer={getFooter()}
      style={{top:'300px'}}
    >
      <div className={className} >
        <PreTagLine>{messageText}</PreTagLine>
      </div>
    </Modal>
  );
}

export default NoticeConfirmModal;
